import { ApiReactiveService, type ApiServiceUseFetchOptions } from '@composable-api/service/api.reactive-service'
import { type MaybeRefOrGetter, toValue } from 'vue'
import { CartItemModel } from '@simploshop-models/cart-item.model'
import type { ApiServiceFetchOptions } from '@composable-api/service/api.service'
import type { CartItemPayload } from '@simploshop-services/CartItems.service'

class CartItemsBatchApiService<M extends CartItemModel> extends ApiReactiveService<M> {
    post(
        data: {
            items: CartItemPayload[]
        },
        options?: ApiServiceFetchOptions<M>
    ) {
        return this.fetch({
            ...options,
            method: 'POST',
            body: data,
        })
    }
}

export function useCartItemsBatchApiService(options: {
    cartId?: MaybeRefOrGetter<string | null | undefined>
}) {
    return new CartItemsBatchApiService({
        endpoint: () => `/carts/${toValue(options.cartId)}/items/batch`,
    }, CartItemModel)
}
